import { render, staticRenderFns } from "./KnowledgeBase.vue?vue&type=template&id=5bc0b636&scoped=true&"
import script from "./KnowledgeBase.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeBase.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeBase.vue?vue&type=style&index=0&id=5bc0b636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc0b636",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ec2-user/buildAgent/work/1ca6ccddf1d626f9/resources/vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
